import {registerNode, Rect, loadJS} from '@topology/core'
import { FlvPlayer } from './flvJs'
export function register() {
  if (!window.flvjs) {
    loadJS('/static/js/oss-player/flv.js', function () {
      registerNode('FlvPlayer', FlvPlayer, null, function (node) {
        node.iconRect = new Rect(node.rect.x, node.rect.y, node.rect.width, node.rect.height)
        node.fullIconRect = node.rect
      }, null)
    }, true)
  } else {
    registerNode('FlvPlayer', FlvPlayer, null, function (node) {
      node.iconRect = new Rect(node.rect.x, node.rect.y, node.rect.width, node.rect.height)
      node.fullIconRect = node.rect
    }, null)
  }
}
// # sourceMappingURL=register.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/flvPlayer/register.js